module.exports = __webpack_public_path__ + "img/97.02964840.jpg";